import React from 'react';
import {formatData} from "../../js/shared-functions";

class DpcElencoCard extends React.Component {

    getText(text){
        if(!text || typeof text !== "string")
            return "";

        const regex = /(( ?)<\/?(?:a)[^>]*>)|<[^>]+>( ?)/ig;
        const subst = `$1`;
        const body = text.replace(regex, subst);

        if(body.length <= 250)
            return body;
        const subString = body.substr(0, 249);
        return subString.substr(0, subString.lastIndexOf(" ")) + "...";
    }

    titleCase() {
        if(this.props.categoria) {
            const splitStr = this.props.categoria.replace('_', ' ').toLowerCase().split(' ');
            for (let i = 0; i < splitStr.length; i++) {
                // You do not need to check if i is larger than splitStr length, as your for does that for you
                // Assign it back to the array
                splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
            }
            // Directly return the joined string
            return splitStr.join(' ');
        }
        else {
            return '';
        }
    }

    render() {
        return (
            <article className="card-wrapper">
                <div className="card">
                    <div className="card-body">
                        <div className="category-top">
                            <span className="category">{this.titleCase()}</span>
                            <span className="data">{formatData(this.props.data_creazione, this.props.dataFormat, this.props.lang)}</span>
                        </div>
                        <h2 className="h5 card-title">
                            <a href={this.props.slug}>{this.props.title}</a>
                        </h2>
                        <div className="card-text"
                             dangerouslySetInnerHTML={{__html: this.getText(this.props.body)}}/>
                    </div>
                </div>
            </article>
        );
    }

}


export default DpcElencoCard;
